module.exports = __webpack_public_path__ + "img/banner_service_2.f66896a4.png";